module.exports = __webpack_public_path__ + "img/cb-search-clear.eabd50a0.svg";